"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 */
class SummaryCounter {
    constructor(count, key, value, defValue, version, variation) {
        this.count = count;
        this.key = key;
        this.value = value;
        this.version = version;
        this.variation = variation;
        this.default = defValue;
    }
    increment() {
        this.count += 1;
    }
}
exports.default = SummaryCounter;
//# sourceMappingURL=SummaryCounter.js.map